// AUTO-GENERATED by scripts/inject-build-info.js — do not edit manually
export const BUILD_INFO = {
  commitHash: 'dev',
  buildTime: '2026-11-03T19:44:40.585Z',
} as const;
